import { environment } from './environments/environment';

const amplifyConfig = {
  Auth: {
    Cognito: {
      identityPoolId: environment.auth.identityPoolId,
      userPoolId: environment.auth.userPoolId,
      userPoolClientId: environment.auth.userPoolWebClientId,
      region: environment.auth.region,
      loginWith: {
        username: true,
        email: true,
        phone: false
      }
    }
  },
  API: {
    REST: environment.API.endpoints.reduce<Record<string, { endpoint: string; region: string }>>(
      (acc, endpoint) => {
        acc[endpoint.name] = {
          endpoint: endpoint.endpoint,
          region: endpoint.region
        };
        return acc;
      },
      {}
    )
  }
};

export default amplifyConfig;
